import InstantWinPrizePanel from './instantWinPrizePanel.container'

export default InstantWinPrizePanel